import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  useUserEmail,
  useUserDisplayName,
  useUserUid,
  useTenant,
} from "hooks/settings";

/**
 * Sets Sentry user context when the user is authenticated.
 * This enables tracking individual users and their sessions in Sentry.
 */
export const SentryUserTracker = () => {
  const userUid = useUserUid();
  const email = useUserEmail();
  const displayName = useUserDisplayName();
  const tenant = useTenant();

  useEffect(() => {
    if (userUid) {
      Sentry.setUser({
        id: userUid,
        email: email ?? undefined,
        username: displayName || undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [userUid, email, displayName]);

  // Set tenant as a tag so you can filter by tenant in Sentry
  useEffect(() => {
    if (tenant && tenant !== "sign-in" && tenant !== "") {
      Sentry.setTag("tenant", tenant);
      Sentry.setContext("tenant", {
        name: tenant,
      });
    }
  }, [tenant]);

  return null;
};
